module.exports = __webpack_public_path__ + "img/catalog.0791afb8.svg";